/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_organization_requestCreateOrganizationFromPortalOffice } from '../models/api_organization_requestCreateOrganizationFromPortalOffice';
import type { api_organization_requestGetOrganization } from '../models/api_organization_requestGetOrganization';
import type { api_organization_requestSearchOrganizations } from '../models/api_organization_requestSearchOrganizations';
import type { api_organization_requestUpdateOrganization } from '../models/api_organization_requestUpdateOrganization';
import type { api_organization_responseCreateOrganizationFromPortalOffice } from '../models/api_organization_responseCreateOrganizationFromPortalOffice';
import type { api_organization_responseGetOrganization } from '../models/api_organization_responseGetOrganization';
import type { api_organization_responseHideRejectedOrganization } from '../models/api_organization_responseHideRejectedOrganization';
import type { api_organization_responseSearchOrganizations } from '../models/api_organization_responseSearchOrganizations';
import type { api_organization_responseUpdateOrganization } from '../models/api_organization_responseUpdateOrganization';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class OrganizationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create Organization from Portal Office
     * 掲載側オフィスをコピーして紹介側組織を作成する
     * @returns api_organization_responseCreateOrganizationFromPortalOffice responseCreateOrganizationFromPortalOffice
     * @throws ApiError
     */
    public postOrganizationCreateFromPortalOffice({
        body,
    }: {
        /**
         * requestCreateOrganizationFromPortalOffice
         */
        body: api_organization_requestCreateOrganizationFromPortalOffice,
    }): CancelablePromise<api_organization_responseCreateOrganizationFromPortalOffice> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organization/create_from_portal_office',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Organization
     * Get Organization
     * @returns api_organization_responseGetOrganization responseGetOrganization
     * @throws ApiError
     */
    public postOrganizationGet({
        body,
    }: {
        /**
         * requestGetOrganization
         */
        body: api_organization_requestGetOrganization,
    }): CancelablePromise<api_organization_responseGetOrganization> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organization/get',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Hide Rejected Organization
     * 却下された組織を所属一覧（iBowマイページ・けあログっと事業所選択）から非表示にする
     * @returns api_organization_responseHideRejectedOrganization responseHideRejectedOrganization
     * @throws ApiError
     */
    public postOrganizationHideRejected(): CancelablePromise<api_organization_responseHideRejectedOrganization> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organization/hide_rejected',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search Organizations
     * 名前またはコードで、承認済みの組織を検索する
     * @returns api_organization_responseSearchOrganizations responseSearchOrganizations
     * @throws ApiError
     */
    public postOrganizationSearch({
        body,
    }: {
        /**
         * requestSearchOrganizations
         */
        body: api_organization_requestSearchOrganizations,
    }): CancelablePromise<api_organization_responseSearchOrganizations> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organization/search',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Organization
     * Update Organization
     * @returns api_organization_responseUpdateOrganization responseUpdateOrganization
     * @throws ApiError
     */
    public postOrganizationUpdate({
        body,
    }: {
        /**
         * requestUpdateOrganization
         */
        body: api_organization_requestUpdateOrganization,
    }): CancelablePromise<api_organization_responseUpdateOrganization> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organization/update',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
